import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;
const TOKEN_KEY = "atlas_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    // chaves legadas/possíveis de versões anteriores
    ["token", "access_token", "id_token", "atlas_user", "sop_token"].forEach((k) =>
      localStorage.removeItem(k)
    );
    // limpa estado do PKCE/OAuth
    sessionStorage.removeItem("sop_oauth_state");
    sessionStorage.removeItem("sop_oauth_verifier");
    // expira cookies de autenticação corrompidos (nomes e domínios comuns)
    const names = ["atlas_token", "token", "access_token", "session", "sopraft_session"];
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const domains = ["", `; domain=${host}`, "; domain=.fawkesatlascore.link"];
    names.forEach((n) =>
      domains.forEach((d) => {
        document.cookie = `${n}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${d}`;
      })
    );
  } catch (_) { /* noop */ }
};

export const SOP_RAFT_TEMPLATE =
  process.env.REACT_APP_SOP_RAFT_INGREDIENT_URL_TEMPLATE ||
  "https://sopraftcozinhainteligente.link/ingredients/{sop_raft_id}";

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function devLogin(sub, roles) {
  const { data } = await axios.post(`${API}/auth/dev/login`, { sub, roles });
  setToken(data.access_token);
  return data;
}
export async function verify() {
  const { data } = await client.get(`/auth/verify`);
  return data;
}
export async function exchangeSso(payload) {
  const { data } = await axios.post(`${API}/auth/sso/exchange`, payload);
  return data;
}
export async function getNetwork(sopId, depth = 1, limit = 60) {
  const { data } = await client.get(
    `/graph/ingredient/${encodeURIComponent(sopId)}/network`,
    { params: { depth, limit } }
  );
  return data;
}
export async function getPairings(ids, pairing_type, min_score = 0) {
  const params = { ingredients: ids.join(","), min_score };
  if (pairing_type) params.pairing_type = pairing_type;
  const { data } = await client.get(`/graph/pairings`, { params });
  return data;
}
export async function ragQuery(question, top_k = 5) {
  const { data } = await client.post(`/rag/query`, { question, top_k });
  return data;
}
export async function souschefChat(message, session_id) {
  const { data } = await client.post(`/souschef/chat`, { message, session_id });
  return data;
}
export async function listSessions() {
  const { data } = await client.get(`/souschef/sessions`);
  return data;
}
export async function getSession(sessionId) {
  const { data } = await client.get(`/souschef/sessions/${encodeURIComponent(sessionId)}`);
  return data;
}
export async function getPairingMatrix(ingredients) {
  const { data } = await client.post(`/intelligence/pairing-matrix`, { ingredients });
  return data;
}
export async function getSubstitutes(sopId, limit = 5, min_similarity = 0) {
  const { data } = await client.get(
    `/intelligence/substitutes/${encodeURIComponent(sopId)}`,
    { params: { limit, min_similarity } }
  );
  return data;
}
export async function costEstimate(ingredients) {
  const { data } = await client.post(`/intelligence/cost-estimate`, { ingredients });
  return data;
}
export async function listRecipes(limit = 50) {
  const { data } = await client.get(`/recipes`, { params: { limit } });
  return data;
}
export async function getConfig() {
  const { data } = await client.get(`/config`);
  return data;
}
export async function searchLibrary(q, top_k = 10) {
  const { data } = await client.get(`/library/search`, { params: { q, top_k } });
  return data;
}
export async function getSyncIngredients() {
  const { data } = await client.get(`/sync/ingredients`);
  return data;
}
export async function getSyncStatus() {
  const { data } = await client.get(`/sync/status`);
  return data;
}
export async function syncPull() {
  const { data } = await client.post(`/sync/pull`);
  return data;
}
export async function listDocuments() {
  const { data } = await client.get(`/library/documents`);
  return data;
}
export async function ingestDocument(file, meta = {}) {
  const fd = new FormData();
  fd.append("file", file);
  if (meta.title) fd.append("title", meta.title);
  if (meta.categories) fd.append("categories", meta.categories);
  const { data } = await client.post(`/library/ingest`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
